import { DeviceChangesText } from '@ingenico/react-ui/device-changes-text';
import classNames from 'classnames';
import type { ReactNode } from 'react';
import type { DeviceChangeDetailsPageContainerProps } from './DeviceChangeDetailsPageContainer.model';
import styles from './DeviceChangeDetailsPageContainer.module.scss';
import { DeviceChangeDetails } from '../device-change-details/DeviceChangeDetails.ctrl';

export function DeviceChangeDetailsPageContainer({
  targetDeviceIdItem,
  targetDeviceGeneralItems,
  errorMessage,
}: DeviceChangeDetailsPageContainerProps): ReactNode {
  return (
    <>
      {targetDeviceIdItem.info && (
        <DeviceChangeDetails {...targetDeviceIdItem} errorMessage={errorMessage}></DeviceChangeDetails>
      )}
      <div className={classNames(styles.targetDeviceDetailsContainer)}>
        {targetDeviceGeneralItems.map(({ subTitle, value, halfSizeField, link }) => (
          <div
            key={subTitle}
            className={classNames({
              [styles.targetDeviceDetailsContainer__subTitleContainer__item_half]: halfSizeField,
            })}
          >
            <DeviceChangesText subTitle={subTitle} link={link} value={value} />
          </div>
        ))}
      </div>
    </>
  );
}
